<template>
  <div :class="['top_search_bar', manualDraw ? 'disable' : '']">
    <div class="bar_left">
      <div class="none-op" v-if="manualDraw"></div>
      <span :class="{'crowd_forbid': isImport}" @click.stop="() => { if (!isImport) showCondition = 'people' }">
        目标人群 <i class="el-icon-arrow-down"></i>
      </span>
      <span @click.stop="showCondition = 'during'">
        {{ allCondition.contentTime ? allCondition.contentTime + '秒' : '购买时长' }}
        <i class="el-icon-arrow-down"></i>
      </span>
      <span style="position: relative;">
        <div v-if="isToday" class="today_tip">温馨提示：选择今天投放，将从当前时间计算播放次数</div>
        {{ allCondition.time && allCondition.time.length > 0 ? allCondition.time[0] + '~' + allCondition.time[1] : '投放时间' }}
        <i class="el-icon-arrow-down"></i>
        <el-date-picker value-format="yyyy-MM-dd" v-model="allCondition.time" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOpt"
          style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0" @focus="showCondition = 'time'">
        </el-date-picker>
      </span>
      <span @click.stop="showCondition = 'timeRange'">投放时段<i class="el-icon-arrow-down"></i></span>
      <!-- <el-select class="region_select" placeholder="选择展现位置" popper-class="display_region" v-model="allCondition.displayRegion" @focus="showCondition = ''">
        <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
      </el-select> -->
      <span @click.stop="showCondition = 'noPlayingLabels'">禁播标签<i class="el-icon-arrow-down"></i></span>
    </div>
    <div class="bar_right">
      <div class="none-op" v-if="manualDraw"></div>
      <span @click="onReset">重置</span>
    </div>
    <PeopleInfo v-if="showCondition === 'people'" v-model="peopleParams" @close="showCondition = ''"
      @profileChange="data => peopleParams.personsLabelData = data"></PeopleInfo>
    <div v-if="showCondition === 'during'" @click.stop class="drop_info during">
      <p v-for="(item, i) in contentTimes" :key="i" :class="{ 'cur': contentTimeIdx == i }" @click="() => {
        contentTimeIdx = i
        allCondition.contentTime = item.dictItemName
        showCondition = false
      }">{{ item.dictItemName + '秒' }}</p>
    </div>
    <div v-if="showCondition === 'timeRange'" @click.stop class="drop_info time_range">
      <SearchTimeRange @submit="timeRangeChange" ref="timeRangeRef"></SearchTimeRange>
    </div>
    <NewNoPlayLabel v-if="showCondition === 'noPlayingLabels'" @click.stop :all="noPlayingLabels" v-model="allCondition.noPlayingLabels" @close="showCondition = ''"></NewNoPlayLabel>
  </div>
</template>

<script>
import SearchTimeRange from '@/components/SearchTimeRange'
import PeopleInfo from './PeopleInfo'
import NewNoPlayLabel from "@/views/PutOrderMap/mapPut/NewNoPlayLabel";

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: "SearchCondition",
  components: {NewNoPlayLabel, SearchTimeRange, PeopleInfo },
  data() {
    return {
      showCondition: '',
      peopleType: 'sex',
      allCondition: {
        contentTime: '',
        time: [],
        displayRegion: 1,
        noPlayingLabels:[],
      },
      contentTimes: [],
      contentTimeIdx: -1,
      curPoint: null,
      datePickerOpt: {
        disabledDate(t) {
          return new Date(t) - dateNow < - dayMs || new Date(t) - dateNow > 92 * dayMs
        }
      },
      isToday: false,
      peopleParams: {},
      isNoNeedReq: false
    }
  },
  computed: {
    manualDraw() {
      return this.$store.state.bmap.manualDraw // 绘制模式
    },
    // 是否导入连锁店/小区搜索
    isImport() {
      return this.$store.state.bmap.exportPointData.hasOwnProperty('successCount')
    },
    isInitRequest() {
      return this.$store.state.bmap.isInitResquest
    },
    isOperateReset() {
      return this.$store.state.bmap.isOperateReset
    },
    noPlayingLabels(){
      return this.$store.state.common['NEW_NO_PLAY_LABLE']
    }
  },
  watch: {
    'allCondition.time'(v) {
      if (!v || v.length < 2) return
      let duration = 30 * 24 * 60 * 60 * 1000 // 限制最多选取31天
      if (new Date(v[1]) - new Date(v[0]) > duration) {
        this.allCondition.time[1] = new Date(new Date(v[0]).getTime() + duration).format().slice(0, 10)
        this.messageTip('最长选择31天')
      }
      this.$store.commit('setStoreData', {
        key: ['mapSearchOptions', 'time'],
        value: v
      })
      if (v[0] && v[0] == dateNow.format().slice(0, 10)) this.isToday = true
      else this.isToday = false
    },
    'allCondition.contentTime'(v) {
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'contentTime'], value: v })
    },
    'allCondition.displayRegion'(v) {
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'displayRegion'], value: v })
      if (!this.isInitRequest && !this.isOperateReset) this.$emit('search')
    },
    'allCondition.noPlayingLabels'(v) {
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'noPlayingLabels'], value: v })
      if (!this.isInitRequest && !this.isOperateReset) this.$emit('search')
    },
    peopleParams(v) {
      if (this.isNoNeedReq) return
      if (!this.isInitRequest && !this.isOperateReset) this.$emit('search')
    },
    '$store.state.bmap.mapSearchOptions': {
      deep: true,
      handler(v) {
        if (!this.isInitRequest && !this.isOperateReset) this.$emit('search')
      }
    },
    showCondition(v) {
      if (v) this.$root.$emit('mapListSpreadClose')
    },
    manualDraw(v) {
      if (v) { // 画圈选屏时目标人群处理
        this.isNoNeedReq = true // 防止下面 peopleParams 置为 空对象的时候 触发 peopleParams 的watch 触发请求，增加 isNoNeedReq 控制不请求
        this.clearLabelPersonStore()
        this.peopleParams = {}
        // 须延迟重置 isNoNeedReq 为flase，不然peopleParams的watch依然会被触发
        setTimeout(() => { this.isNoNeedReq = false })
      }
    }
  },
  async created() {
    // 初始化默认数据
    let loading = this.$loading({ target: '.p-main' })
    await this.resetSearchData()
    loading.close()
    // 初始化时首次自动请求
    const t = setTimeout(() => { // 延迟保证loading 动画再次显示正常
      clearTimeout(t)
      this.$emit('search')
    }, 300)
  },
  mounted() {
    document.body.addEventListener('click', this.bodyClick)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.bodyClick)
  },
  methods: {
    bodyClick(e) {
      this.showCondition = ''
      if (this.isToday && !e.target.classList.contains('el-loading')) this.isToday = false
    },
    timeRangeChange(data) {
      this.$store.commit('setStoreData', { key: ['chooseTimeSlot'], value: this.$refs.timeRangeRef.dest })
      this.$emit('search')
    },
    async getContentTimesV1() { // 获取购买时长列表
      let contentTimes = this.$store.state.common['ADVERTSLOTTIME']
      if (contentTimes && contentTimes.length > 0) return contentTimes
      await this.$store.dispatch('getDictItemList', 'ADVERTSLOTTIME')
      contentTimes = this.$store.state.common['ADVERTSLOTTIME']
      return contentTimes || []
    },
    async getContentTimes() { // 获取购买时长列表
      if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
      return this.$store.state.bmap.labelTimeSlotList || []
    },
    clearLabelPersonStore() {
      this.$store.commit('label/setStore', { key: ['confirm', 'labels'], value: [] })
      this.$store.commit('label/setStore', { key: ['confirm', 'persons'], value: [] })
      this.$store.commit('label/setStore', { key: ['operate', 'labels'], value: [] })
      this.$store.commit('label/setStore', { key: ['operate', 'persons'], value: [] })
    },
    async resetSearchData() {
      // 初始化购买时长
      this.contentTimes = await this.getContentTimes()
      let defaultCotentTime = this.contentTimes.filter(el => el.default)[0] // 默认
      if (defaultCotentTime) {
        this.$set(this.allCondition, 'contentTime', defaultCotentTime.dictItemName)
      }
      // 初始化投放日期
      this.allCondition.time = [
        new Date(+dateNow + 2 * dayMs).format().slice(0, 10),
        new Date(+dateNow + 8 * dayMs).format().slice(0, 10)
      ]
      this.allCondition.displayRegion = 1
      // 时段
      this.$store.commit('setStoreData', { key: 'chooseTimeSlot', value: { idx: 0, data: [] } })
      // 目标人群 用户画像
      this.clearLabelPersonStore()
      this.peopleParams = {}
      // 导入小区/连锁店
      this.$store.commit('setImportNbhdList', [])
      this.$store.commit('setImportPointList', [])
      this.$store.commit('setImportPointData', {})
      //重置新禁播标签
      this.$set(this.allCondition, 'noPlayingLabels', [])
    },
    onReset() {
      this.$root.$emit('mapListSpreadClose')
      this.$confirm('此操作将重置所有数据，确认重置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 点击重置开始就把 isOperateReset 设为 true 以防初始化数据多次触发请求
        this.$store.commit('setReset', true)
        // 初始化各个数据
        await this.resetSearchData()
        this.showCondition = ''
        this.$emit('reset')
      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消重置'
        // });
      })
    },
    search() {
      this.$emit('search')
    },
    selectPeopleTag(item) {
      if (!item) { // 不限
        this.allCondition[this.peopleType] = []
        return
      }
      if (item.select) {
        this.allCondition[this.peopleType] = this.allCondition[this.peopleType].filter(value => {
          return value !== item.value
        })
      } else {
        let multiple = this.peopleType !== 'sex'
        if (multiple) {
          this.allCondition[this.peopleType].push(item.value)
        } else {
          this.allCondition[this.peopleType] = [item.value]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.display_region.el-select-dropdown.el-popper {
  border: none;
  .el-select-dropdown__item.selected {
    color: #FF3973;
  }
}
</style>

<style lang="scss" scoped>
.today_tip {
  position: absolute;
  top: -45px;
  left: 20px;
  width: 210px;
  background: #282729;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  padding: 6px 10px;
  text-align: left;
  &::after {
    position: absolute;
    content: "";
    bottom: -8px;
    left: 32px;
    border-top: 8px solid #282729;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
  }
}

.top_search_bar {
  position: relative;
  height: 50px;
  box-shadow: 0 1px 0 0 #E9E9E9 inset, -1px 0 0 0 #E9EAE9 inset, 0 -1px 0 0 #E9E9E9 inset, 1px 0 0 0 #E9E9E9 inset;
  z-index: 10;
  &.disable {
    background: #f5f5f5;
    .bar_left, .bar_right {
      span {
        color: #999;
      }
      .region_select ::v-deep .el-input {
        .el-input__inner {
          background-color: #f5f5f5;
          color: #999;
        }
        .el-select__caret {
          color: #999;
        }
      }
    }
  }
}

.none-op {
  cursor: not-allowed;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.bar_left {
  float: left;
  line-height: 50px;
  position: relative;
  span {
    position: relative;
    display: inline-block;
    min-width: 120px;
    padding: 0 20px;
    height: 50px;
    text-align: center;
    color: #282729;
    border-right: 1px solid #E9E9E9;
    cursor: pointer;
  }
  .crowd_forbid {
    cursor: not-allowed;
    color: #999;
  }
  .region_select {
    width: 120px;
    border-right: 1px solid #E9E9E9;
    ::v-deep .el-input {
      .el-input__inner {
        border: none;
        padding: 0 20px;
      }
      .el-input__suffix {
        right: 5px;
        .el-select__caret {
          color: #282729;
          right: 0;
          &::before {
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.bar_right {
  float: right;
  padding-top: 18px;
  line-height: 14px;
  position: relative;

  span {
    display: inline-block;
    width: 72px;
    text-align: center;
    color: #D4D4D4;
    cursor: pointer;

    &:last-child {
      color: #FF3973;
      border-left: 1px solid #E9E9E9;
    }
  }
}

.drop_info {
  position: absolute;
  border-radius: 4px;
  background: #FFF;
  top: 60px;
  z-index: 2;
  box-shadow: 0 6px 12px 0 rgba(40, 39, 41, 0.2);
  &.during {
    width: 100px;
    padding: 10px 0;
    left: 130px;
    text-align: center;
    p {
      cursor: pointer;
      line-height: 40px;
      &:hover {
        background: rgba(0, 0, 0, .1);
      }
    }
  }
  &.time_range {
    width: 372px;
    left: 370px;
    z-index: 100;
  }
}
</style>
